import type { KitItem } from "@/types";

interface KitCardProps {
  item: KitItem;
  onEdit: (item: KitItem) => void;
  onDelete: (item: KitItem) => void;
}

// Tarjeta de una pieza del kit dentro del panel del administrador, con las
// mismas proporciones y estilo que las ve el asesor.
const KitCard = ({ item, onEdit, onDelete }: KitCardProps) => (
  <article className="glass-panel rounded-lg overflow-hidden animate-fade-up flex flex-col">
    <div className="w-full h-44 bg-background-200/40">
      <img
        src={item.imageUrl}
        alt={item.title}
        title={`Amway · ${item.title}`}
        className="w-full h-full object-cover object-top"
      />
    </div>
    <div className="p-4 flex flex-col flex-1">
      <h3 className="editable-title text-sm font-bold">{item.title}</h3>
      <p className="text-[11px] md:text-xs text-foreground-600 mt-2 flex-1">{item.text}</p>
      <div className="flex items-center gap-2 mt-4">
        <button
          onClick={() => onEdit(item)}
          className="flex-1 px-3 py-2 rounded-md border border-accent-500/35 text-accent-200 hover:bg-accent-500/10 text-[11px] font-semibold whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-1.5"
        >
          <i className="ri-pencil-line" /> Editar
        </button>
        <button
          onClick={() => onDelete(item)}
          className="px-3 py-2 rounded-md border border-primary-500/40 text-primary-200 hover:bg-primary-500/10 text-[11px] font-semibold whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-1.5"
          aria-label="Eliminar pieza"
          title="Eliminar pieza"
        >
          <i className="ri-delete-bin-6-line" />
        </button>
      </div>
    </div>
  </article>
);

export default KitCard;